import React from "react";

// Function to clean and validate the percentage
const cleanPercentage = (percentage: number): number => {
  const tooLow = !Number.isFinite(percentage) || percentage < 0;
  const tooHigh = percentage > 100;
  return tooLow ? 0 : tooHigh ? 100 : percentage;
};

// Props for the Circle component
interface CircleProps {
  colour: string;
  pct?: number; // Optional because the first circle doesn't require it
}

// Circle Component
const Circle: React.FC<CircleProps> = ({ colour, pct = 100 }) => {
  const r = 25; // Radius of the circle
  const circ = 2 * Math.PI * r; // Circumference
  const strokePct = ((100 - pct) * circ) / 100; // Calculate stroke offset
  return (
    <circle
      r={r}
      cx={150}
      cy={80}
      fill="transparent"
      stroke={strokePct !== circ ? colour : ""}
      strokeWidth={"0.5rem"}
      strokeDasharray={circ}
      strokeDashoffset={pct ? strokePct : 0}
      strokeLinecap="round"
    ></circle>
  );
};

// Props for the Text component
interface TextProps {
  percentage: number;
}

// Text Component
const Text: React.FC<TextProps> = ({ percentage }) => {
  return (
    <text
      x="50%"
      y="50%"
      dominantBaseline="central"
      textAnchor="middle"
      fontSize={"1.5em"}
    >
      {percentage.toFixed(0)}%
    </text>
  );
};

// Props for the ProgressCircle component
interface PieProps {
  percentage: number;
  colour: string;
  heading:String;
}

// Pie Component
const ProgressCircle: React.FC<PieProps> = ({ percentage, colour,heading }) => {
  const pct = cleanPercentage(percentage);
  return (
    <>
    <div className="progress-circle-wrapper">
    <svg width={150} height={100}>
      <g transform={`rotate(-90 ${"100 100"})`}>
        <Circle colour="#E8E8E8" /> {/* Background circle */}
        <Circle colour={colour} pct={pct} /> {/* Progress circle */}
      </g>
    </svg>
       <div className="progress-circle-text">
       <h5>{heading}</h5>
       <span>{percentage}%</span>
     </div>
     </div>
     </>
  );
};

export default ProgressCircle;
